module.exports = __webpack_public_path__ + "img/zhuanpan.c7e0d6be.png";